const types = {
  SET_SHOW_RELEASE_NOTES: 'SET_SHOW_RELEASE_NOTES',
  }

  export default types;